// 配置 首页
export default [{
	path: '*',
	component: () => import('@/views/index/404.vue')
},{
	path: '/',
	redirect: "/index",
	component: () => import('@/views/index/404.vue')
},
{
  //首页
  path: '/index',
  name: 'index',
  // component: () => import('@/views/index/index.vue'),
  component: () => import('@/views/index/index-v3.vue'),
  meta: {
    metaInfo: {
      title: "新语境 | 新语境教育 | 新语境模式 | 新语境幼儿园 | 北京新语境官网",
      keywords: "新语境,新语境教育,新语境模式,新语境幼儿园,幼师培训,幼师考证,儿童绘本,新语幼师培训,幼师标准,幼师就业,新语境幼儿园,幼师资格证报考条件",
      description: "新语境教育官网是集幼师培训,幼师考证,幼师就业,儿童幼儿绘本,新语境教育模式,职业技能提升,新语境幼儿园,一站式学前教育科技综合服务平台",
    },
  }
},
{
  //资讯
  path: '/news',
  name: 'news',
  // component: () => import('@/views/index/news.vue')
  component: () => import('@/views/index/news-v3.vue')
},
{
  //资讯详情
  path: '/news/details/:id',
  name: 'newsDetails',
  component: () => import('@/views/index/newsDetails.vue')
},
{
  //走进新语境
  path: '/kmledu',
  name: 'kmledu',
  component: () => import('@/views/index/kmledu-v3.vue')
},
{
  //团体标准
  path: '/standards',
  name: 'standards',
  component: () => import('@/views/index/groupStandards-v3.vue')
},
{
  //团体标准详情
  path: '/standards/detail/:type',
  name: 'standardsDetail',
  component: () => import('@/views/index/groupStandardsDetail-v3.vue')
},
{
  //示范展示
  path: '/example',
  name: 'example',
  component: () => import('@/views/index/example-v3.vue')
},
{
  //合作中心
  path: '/cooperation',
  name: 'cooperationCenter',
  component: () => import('@/views/index/cooperation-center-v3.vue')
},
{
  //服务中心
  path: '/service',
  name: 'serviceCenter',
  component: () => import('@/views/index/serviceCenter-v3.vue')
},
{
  //免责声明
  path: '/statement',
  name: 'statement',
  component: () => import('@/views/index/statement.vue')
},{
  //意见建议
  path: '/advice',
  name: 'advice',
  component: () => import('@/views/index/advice.vue')
},{
  //资讯
  path: '/consult',
  name: 'consult',
  component: () => import('@/views/index/consult.vue')
},{
  //资讯
  path: '/message',
  name: 'message',
  component: () => import('@/views/index/message.vue')
}]



// WEBPACK FOOTER //
// ./src/router/modules/index.js